import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const JikanShiteiKbn = props => {
  return <Dropdown.Static kubunKey='jikan_shitei_kbn' {...props} />
}
